import { RelationContextType } from '@components/EntityDrawers/drawers/Relationship/constants/types';

export const MainLabels = {
  [RelationContextType.ServiceCapability]: 'Control requirement',
  [RelationContextType.CapabilityFunction]: 'Control requirement',
  [RelationContextType.FunctionTechnology]: 'Control requirement',
} as const;

export const UnderLabels = {
  [RelationContextType.ServiceCapability]: 'Underpinning control requirements',
  [RelationContextType.CapabilityFunction]: 'Underpinning control requirements',
  [RelationContextType.FunctionTechnology]: '-',
} as const;

export const UnderPlaceholders = {
  [RelationContextType.ServiceCapability]: 'Control requirement',
  [RelationContextType.CapabilityFunction]: 'Control requirement',
  [RelationContextType.FunctionTechnology]: '-',
} as const;
